import {
    Stack, Flex, Image, HStack, Link, Box, Button, useDisclosure, Menu,
    IconButton,
    Collapse,
    useColorModeValue,
    useToast,
    Avatar


} from "@chakra-ui/react";
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { ChevronDownIcon, HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
import { ForgotPassword } from '../Modal/ForgotPasswordModal';
import { LoginModal } from '../Modal/LoginModal';
import { ResetPassword } from '../Modal/ResetPassowrdCard';
import { SignupModal } from '../Modal/SignupModal';
import VerificationModal from "../Modal/VerificationModal";
import { GET_USER_DATA } from '../../Components/Graphql/Queries';
import { useLazyQuery } from '@apollo/client';
import { jwtDecode } from 'jwt-decode';





const LandingPgHeader = () => {
    const toast = useToast();
    let navigate = useNavigate();
    const { isOpen, onToggle } = useDisclosure();
    const { isOpen: isOpenLoginModal, onClose: onCloseLoginModal, onOpen: onOpenLoginModal } = useDisclosure()
    const { isOpen: isOpenSignupModal, onClose: onCloseSignupModal, onOpen: onOpenSignupModal } = useDisclosure()
    const { isOpen: isOpenForgotPasswordModal, onClose: onCloseForgotPasswordModal, onOpen: onOpenForgotPasswordModal } = useDisclosure()
    const { isOpen: isOpenResetPasswordModal, onClose: onCloseResetPasswordModal, onOpen: onOpenResetPasswordModal } = useDisclosure()
    const { isOpen: isOpenVerificationModal, onClose: onCloseVerificationModal, onOpen: onOpenVerificationModal } = useDisclosure()
    const [token, setToken] = useState();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [getUserDataQuery, { loading, error, data }] = useLazyQuery(GET_USER_DATA);
    const [profileUrl, setProfileUrl] = useState(null);
    const [firstName, setFirstName] = useState('');

    const checkLoginStatus = () => {
        let tempToken = sessionStorage.getItem('token')
        setToken(tempToken);
        if (tempToken) {
            setIsLoggedIn(true)
        } else {
            setIsLoggedIn(false)
        }
    }
    const handleClickProfileAvatar = () => {
        const decodedJWT = jwtDecode(token);
        navigate(decodedJWT.role === 'User' ? '/profile' : '/admin-dashboard');
    }
    const handleGetUser = async () => {
        await getUserDataQuery();
    };


    useEffect(() => {
        checkLoginStatus();
    }, [])

    useEffect(() => {
        if (isLoggedIn) {
            handleGetUser();
        }
    }, [isLoggedIn])
    useEffect(() => {

        console.log("error:", error)
        console.log("loading:", loading)
        console.log("data:", data)

        if (data != undefined) {
            console.log("data of user: ", data);
            setFirstName(data.getUserData.firstName);
            setProfileUrl(data.getUserData.profileImage)

        }
        if (error != undefined) {
            toast({
                title: 'error',
                description: error.message,
                status: 'error',
                duration: 4000,
                isClosable: true,
                position: "bottom-left"
            });
        }
    }, [data, loading, error])
    return (
        <Stack align="center" px={{ base: "14px", xl: "10vw" }} >
            <Flex justify="space-between" w="100%" maxW="1171px" fontSize="17px">
                <Flex
                    align="center"
                    display={{ base: 'flex', lg: 'none' }}>
                    <IconButton
                        onClick={onToggle}
                        icon={
                            isOpen ? <CloseIcon w={3} h={3} /> : <HamburgerIcon w={5} h={5} />
                        }
                        variant={'ghost'}
                        aria-label={'Toggle Navigation'}
                    />
                </Flex>
                <Box w={{ base: "auto", lg: "140px" }}>
                    <Image
                        onClick={() => navigate('/')}
                        cursor="pointer"
                        style={{ mixBlendMode: 'multiply' }}
                        boxSize='80px'
                        objectFit='cover'
                        src="https://static.vecteezy.com/system/resources/thumbnails/008/646/755/small/real-estate-logo-design-vector.jpg" />
                </Box>
                <HStack display={{ base: "none", lg: "flex" }} justify="space-between" color="#1C3E64" w="500px" >
                    {/* <Menu>
                        <MenuButton _hover={{ textDecoration: "none" }} fontWeight="400" as={Button} color="#1C3E64" variant="link" rightIcon={<ChevronDownIcon />}>
                            Properties
                        </MenuButton>
                        <MenuList>
                            <MenuItem onClick={() => navigate('/marketplace')}>Marketplace</MenuItem>
                            <MenuItem  onClick={() => navigate('/submitYourProperty')}>Submit a Property</MenuItem>
                        </MenuList>
                    </Menu> */}
                    {/* <Link _hover={{ textDecoration: "none" }}>The Exchange</Link> */}
                    <Link onClick={() => navigate('/')} _hover={{ textDecoration: "none" }}>Home</Link>
                    <Link onClick={() => navigate('/marketplace')} _hover={{ textDecoration: "none" }}>Marketplace</Link>
                    <Link onClick={() => navigate('/aboutus')} _hover={{ textDecoration: "none" }}>About Us</Link>
                    <Link onClick={() => navigate('/contactus')} _hover={{ textDecoration: "none" }}>Contact Us</Link>

                </HStack>
                <HStack>
                    {isLoggedIn ? <Avatar
                        name={firstName}
                        src={profileUrl ? profileUrl : 'https://bit.ly/broken-link'}
                        onClick={handleClickProfileAvatar}
                        cursor='pointer'
                    /> :
                        <> <Button
                            fontSize="17px"
                            w={{ base: "70px", sm: "92px" }}
                            mr="8px"
                            fontWeight={400}
                            variant="ghost"
                            border="1px solid #1C3E64"
                            onClick={() => {
                                onOpenLoginModal()
                            }}>
                            Sign In
                        </Button>
                            <Button
                                w="140px"
                                display={{ base: "none", lg: "block" }}
                                fontSize="17px"
                                fontWeight={600}
                                color={'white'}
                                _hover={{ color: "#002B5B", bgColor: "white", border: "1px solid #002B5B" }}
                                bgColor="#002B5B"
                                onClick={() => {
                                    onOpenLoginModal()
                                }}
                            >
                                Get Started
                            </Button>
                        </>
                    }



                </HStack>


            </Flex>
            <Collapse in={isOpen} animateOpacity>
                <Stack
                    bg={useColorModeValue('white', 'gray.800')}
                    p={4}
                    display={{ lg: 'none' }}
                >
                    <Stack spacing={4} justify="center">
                        {/* <Menu >
                            <MenuButton _hover={{ textDecoration: "none" }} fontWeight="400" as={Button} color="#1C3E64" variant="link" rightIcon={<ChevronDownIcon />}>
                                Properties
                            </MenuButton>
                            <MenuList>
                                <MenuItem onClick={() => navigate('/marketplace')}>Marketplace</MenuItem>
                                <MenuItem onClick={() => navigate('/submitYourProperty')} >Submit a Property</MenuItem>
                            </MenuList>
                        </Menu> */}
                        {/* <Link _hover={{ textDecoration: "none" }} textAlign="center">The Exchange</Link> */}
                        <Link onClick={() => navigate('/')} _hover={{ textDecoration: "none" }}>Home</Link>
                        <Link onClick={() => navigate('/marketplace')} _hover={{ textDecoration: "none" }}>Marketplace</Link>
                        <Link onClick={() => navigate('/aboutus')} _hover={{ textDecoration: "none" }}>About Us</Link>
                        <Link onClick={() => navigate('/contactus')} _hover={{ textDecoration: "none" }} textAlign="center">Contact Us</Link>
                        {!isLoggedIn && <Button
                            as={'a'}
                            w="110px"
                            p="12px 24px"
                            fontSize="17px"
                            fontWeight={600}
                            color={'white'}
                            _hover={{ color: "#002B5B", bgColor: "white", border: "1px solid #002B5B" }}
                            bgColor="#002B5B"
                            onClick={() => {
                                onOpenSignupModal()
                            }}
                        >
                            Get Started
                        </Button>
                        }
                    </Stack>
                </Stack>
            </Collapse>
            <LoginModal isOpen={isOpenLoginModal} onClose={onCloseLoginModal} onOpenSignupModal={onOpenSignupModal} onOpenForgotPasswordModal={onOpenForgotPasswordModal} />
            <SignupModal isOpen={isOpenSignupModal} onClose={onCloseSignupModal} onOpenLoginModal={onOpenLoginModal} />
            <ForgotPassword isOpen={isOpenForgotPasswordModal} onClose={onCloseForgotPasswordModal} onOpenLoginModal={onOpenLoginModal} onOpenVerificationModal={onOpenVerificationModal} />
            <ResetPassword isOpen={isOpenResetPasswordModal} onClose={onCloseResetPasswordModal} onOpenLoginModal={onOpenLoginModal} onOpenForgotPasswordModal={onOpenForgotPasswordModal} />
            <VerificationModal isOpen={isOpenVerificationModal} onClose={onCloseVerificationModal} onOpenLoginModal={onOpenLoginModal} onOpenResetPasswordModal={onOpenResetPasswordModal} />
        </Stack>

    );
}

export default LandingPgHeader;